<template>
  <div class="cart-header">
    <div class="container">
      <h1 class="cart-header__title">
        {{ $t("services.cart.pageTitle") }}
      </h1>
      <BreadCrumbs :links="breadcrumbs" />
    </div>
  </div>
</template>

<script>
import { BreadCrumbs } from "@v2/shared/ui/components";

export default {
  name: "CartHeader",
  components: { BreadCrumbs },
  props: {
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style lang="scss">
.cart-header {
  background: var(--white, #fff);
  border-bottom: 1px solid var(--gray-darker, #d5dae5);
  padding: 30px 0;
  position: relative;
  z-index: 6;
  @media (max-width: 440px) {
    padding: 15px 0;
  }

  &__title {
    color: var(--dark, #262626);
    font-size: 2.125rem;
    font-weight: 700;
    line-height: normal;
    margin: 0 0 40px 0;

    @media (max-width: 440px) {
      font-size: 1rem;
      font-weight: 700;
      line-height: 24px;
      margin: 0 0 15px 0;
    }
  }
}
</style>
